module.exports = __webpack_public_path__ + "img/ring_y_i_null_null@3x.1457d411.png";